import React, { forwardRef } from 'react';
import { InputText } from 'primereact/inputtext';
import type { InputTextProps } from 'primereact/inputtext';
import './InputAtom.scss';

export interface InputAtomProps extends InputTextProps {
  className?: string;
  /** `inline`: borderless until hover/focus, for in-place editing of a title or description. */
  appearance?: 'default' | 'inline';
}

const InputAtom = forwardRef<HTMLInputElement, InputAtomProps>(
  ({ className = '', appearance = 'default', ...rest }, ref) => (
    <InputText
      ref={ref}
      className={`atlas-input-atom ${appearance === 'inline' ? 'atlas-input-atom--inline ' : ''}${className}`}
      {...rest}
    />
  )
);

InputAtom.displayName = 'InputAtom';
export default InputAtom;
